/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:30
 * @LastEditors: yy
 * @LastEditTime: 2021-02-22 10:27:39
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ExportTable.css';

 class ExportLogo extends React.Component {

  constructor (props) {
    super(props);
  }

  render () {
    const { column, list } = this.props;
    const hasClass = this.props.hasClass || '';
    return (
      <table className={`${s.table} ${hasClass ? s[hasClass]: ''}`}>
        <thead>
          <tr>
            {column.map((item, index) => {
              const w = {width: item.width, minWidth: item.minWidth}

              return (
                <th style={{minWidth: '120px', ...w}} key={index}>{item.name}</th>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {
            list.map((item, index) => {
              return (
                <tr key={index}>
                {
                  column.map((_item, _index) => {
                    return (
                      <td style={_item.style?_item.style:{}} key={_index}> {!_item.render ? item[_item.key] : _item.render(item[_item.key], item, _index)} </td>
                    )
                  })
                }
                </tr>
              )
            })
          }
        </tbody>
      </table> 
    );
  }
}

export default withStyles(s)(ExportLogo);


// WEBPACK FOOTER //
// src/components/ExportTable/ExportTable.js